import { render, staticRenderFns } from "./submitReportModal.vue?vue&type=template&id=2d5f559a&scoped=true"
import script from "./submitReportModal.vue?vue&type=script&lang=js"
export * from "./submitReportModal.vue?vue&type=script&lang=js"
import style0 from "./submitReportModal.vue?vue&type=style&index=0&id=2d5f559a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f559a",
  null
  
)

export default component.exports